import actions from './actionsWallet'
import mutations from './mutationsWallet'
import state from './stateWallet'
import getters from './gettersWallet'

export default {
  actions,
  mutations,
  state,
  getters,
}
